import { Component, Input } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class PortalVersionService {

    constructor(private http: Http) {
    }

    public getVersion(): Observable<any> {
        return this.http.get('./app/portal-version.json')
            .map((res: any) => { return res.json(); })
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/portal-version.service.ts